export function getDocumentRoot(): HTMLElement | undefined {
    const root =
        document.getElementById('fundCenter') ||
        document.getElementById('kurtosysDocLibrary');
    return root;
}

// Helper util to get the shadow root element when using getElementById
export function getShadowRoot(): ShadowRoot | undefined {
    const root = getDocumentRoot();
    return root && root.shadowRoot;
}



// WEBPACK FOOTER //
// ./src/utils/shadowDomHelper.ts